export default __webpack_public_path__ + "static/media/ContactArrow.780328a0.svg";